module.exports = __webpack_public_path__ + "img/light.0ddb87c9.svg";